import type * as lazyIndex from './lazyIndex';
import { LazyAction, LazyModule } from 'owa-bundling';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "PostSharedBoot" */ './lazyIndex'),
    { name: 'PostSharedBoot', prioritize: true }
);

export const lazySetupSharedPostBoot: LazyAction<
    typeof lazyIndex.setupSharedPostBoot,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.setupSharedPostBoot);
export const lazyUpdateAnalyticsSetup: LazyAction<
    typeof lazyIndex.updateAnalyticsSetup,
    typeof lazyModule
> = new LazyAction(lazyModule, m => m.updateAnalyticsSetup);
